import { t } from 'i18next';

import { ErrorResponseErrorItemCodeFile } from '../../../../../typings/api/skymap/rest/v1/.common';

export const translations = (): Record<ErrorResponseErrorItemCodeFile, string> => ({
  'file:revision_exists': t('file.revisionExists', { ns: 'apiErrorCodes' }),
  'file:not_found': t('file.notFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Filen kunde inte hittas.',
  }),
  'file:not_found_multiple': t('file.notFoundMultiple', {
    ns: 'apiErrorCodes',
    defaultValue: 'Filer kunde inte hittas.',
  }),
  'file:user_unauthorized': t('file.userUnauthorized', {
    ns: 'apiErrorCodes',
    defaultValue: 'Du har inte åtkomst till aktuell fil.',
  }),
  'file:user_unauthorized_multiple': t('file.userUnauthorizedMultiple', {
    ns: 'apiErrorCodes',
    defaultValue: 'Du har inte åtkomst till flertalet filer.',
  }),
  'file:name_exists': t('file.nameExists', {
    ns: 'apiErrorCodes',
    defaultValue: 'En fil med samma namn existerar redan.',
  }),
  'file:not_found_in_project': t('file.notFoundInProject', {
    ns: 'apiErrorCodes',
    defaultValue: 'Filen kunde inte hittas i projektet.',
  }),
});
